/**
 * The enumeration defines possible targets for DeleteResources activity.
 *
 * @see https://github.com/Microsoft/MIMWAL/blob/master/src/WorkflowActivityLibrary/Enumerations/DeleteResourcesTargetType.cs
 */
export enum IDGeneratorType {
  /**
   * The last id is saved in a database
   */
  database,

  /**
   * The last id is saved in a file
   */
  file,
}
